<template>
  <svg
    width="173"
    height="173"
    viewBox="0 0 173 173"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Isolation_Mode" clip-path="url(#clip0_2751_1758)">
      <path
        id="Vector"
        d="M124.963 47.1425C127.135 44.2231 128.51 40.691 128.51 36.7985C128.51 27.2475 120.836 19.4985 111.315 19.2102C110.446 8.46979 101.433 0 90.4278 0C81.1606 0 73.3413 5.98292 70.5539 14.2725C67.9113 12.3263 64.7257 11.1008 61.1781 11.1008C55.5671 11.1008 50.6439 13.9842 47.7841 18.3452C45.5397 16.1467 42.4989 14.7771 39.0961 14.7771C32.2905 14.7771 26.7881 20.2554 26.7881 27.0312C26.7881 33.8071 32.2905 39.2854 39.0961 39.2854C42.4989 39.2854 45.5759 37.9158 47.7841 35.7173C50.6439 40.0783 55.5671 42.9617 61.1781 42.9617C65.7393 42.9617 69.8661 41.0154 72.7621 37.9519C75.4047 43.0698 80.7262 46.6379 86.9164 46.6379C89.8124 46.6379 92.4912 45.809 94.808 44.4754C96.4008 47.7552 99.0072 50.4583 102.229 52.1883C100.853 54.531 100.021 57.1981 100.021 60.1175C100.021 68.8396 107.116 75.9037 115.876 75.9037C124.637 75.9037 131.732 68.8396 131.732 60.1175C131.732 54.7473 129.017 50.0258 124.926 47.1425H124.963Z"
        fill="#A9A9A9"
      />
      <path
        id="Vector_2"
        d="M56.8704 81.9946C58.065 80.3727 58.8252 78.4264 58.8252 76.2639C58.8252 70.9658 54.5898 66.6768 49.3046 66.5327C48.834 60.5858 43.8384 55.9004 37.7568 55.9004C32.6526 55.9004 28.3086 59.2162 26.752 63.7935C25.304 62.7123 23.5302 62.0275 21.5754 62.0275C18.4622 62.0275 15.7472 63.6133 14.1544 66.0281C12.9236 64.8027 11.2222 64.0458 9.33979 64.0458C5.57498 64.0458 2.53418 67.0733 2.53418 70.8216C2.53418 74.57 5.57498 77.5975 9.33979 77.5975C11.2222 77.5975 12.9236 76.8406 14.1544 75.6152C15.7472 78.03 18.4622 79.6158 21.5754 79.6158C24.1094 79.6158 26.39 78.5346 27.9828 76.8406C29.467 79.6879 32.3992 81.6341 35.802 81.6341C37.3948 81.6341 38.879 81.1656 40.1822 80.4448C41.0872 82.2829 42.499 83.7606 44.2728 84.7337C43.5126 86.0312 43.042 87.5089 43.042 89.1308C43.042 93.9604 46.9878 97.8889 51.8386 97.8889C56.6894 97.8889 60.6352 93.9604 60.6352 89.1308C60.6352 86.1393 59.1511 83.5443 56.8704 81.9585V81.9946Z"
        fill="#A9A9A9"
      />
      <path
        id="Vector_3"
        d="M45.9375 173.001H89.1603C77.0333 156.205 71.3137 141.104 68.9245 128.525C64.7615 141.861 57.6301 156.854 45.9737 173.001H45.9375Z"
        fill="#595959"
      />
      <path
        id="Vector_4"
        d="M71.6759 90.7168H17.4482C17.4482 90.7168 20.0184 95.9428 21.1406 105.133H67.9473C69.0695 95.9428 71.6397 90.7168 71.6397 90.7168H71.6759Z"
        fill="#7C7C7C"
      />
      <path
        id="Vector_5"
        d="M67.9834 105.133H21.1768C21.575 108.413 21.7922 112.161 21.6474 116.378H67.549C67.4042 112.161 67.6214 108.377 68.0196 105.133H67.9834Z"
        fill="#FF2424"
      />
      <path
        id="Vector_6"
        d="M173 173C151.786 143.554 145.524 118.037 144.836 99.2949H85.106C84.4182 118.037 78.1918 143.554 56.9424 173H172.964H173Z"
        fill="#E2E2E2"
      />
      <path
        id="Vector_7"
        d="M67.5131 116.379H21.6114C21.1046 130.76 16.29 150.366 0 173H45.9378C57.5943 156.818 64.7257 141.86 68.8887 128.525C68.0561 124.164 67.6217 120.091 67.5131 116.379Z"
        fill="#7C7C7C"
      />
      <path
        id="Vector_8"
        d="M150.303 65.8848H79.7129C79.7129 65.8848 83.0795 72.6966 84.5275 84.6625H145.488C146.936 72.6966 150.303 65.8848 150.303 65.8848Z"
        fill="#E2E2E2"
      />
      <path
        id="Vector_9"
        d="M145.452 84.6621H84.4912C84.998 88.915 85.2876 93.8167 85.1066 99.3311H144.837C144.656 93.8167 144.909 88.9511 145.452 84.6621Z"
        fill="#FF2424"
      />
    </g>
    <defs>
      <clipPath id="clip0_2751_1758">
        <rect width="173" height="173" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
